import { t } from '@lingui/macro';
import React from 'react';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { LegendRenderer } from '../../LegendRenderer';
import { CLUSTERED_OPENS_LEGEND } from '../../../constants/legends';

/**
 * ClusteredOpensLegend - Легенда кластеризированных открытий
 *
 * Мигрирована на новую систему легенд (Этап 3)
 * Использует LegendRenderer с типом COLORED_ITEMS и иконкой HEXAGON
 */

const ClusteredOpensLegendComponent = () => (
    <LegendRenderer config={CLUSTERED_OPENS_LEGEND} />
);

export const ClusteredOpensLegend = withDisplayedLayersCheck(
    ClusteredOpensLegendComponent,
    t`Кластеризированные открытия (7 дней)`
);
